import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Meta Pixel
if (typeof window !== 'undefined' && !(window as any).fbq) {
  const n = ((window as any).fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  }) as any;
  (window as any)._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [] as any[];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  s?.parentNode?.insertBefore(t, s);
  (window as any).fbq('init', '1599365181145872');
  (window as any).fbq('track', 'PageView');
}
// Set page title and meta
document.title = 'download now!';
const ogTitle = document.querySelector('meta[property="og:title"]');
if (ogTitle) {
  ogTitle.setAttribute('content', 'download now!');
}
render(<App data-id="element-154" />, document.getElementById('root'));